import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { AppConfig } from "../../app.config";
import { HolidayListService } from "../../shared/service/holidaylist.service";
import { UserService } from "../../shared/service/user.service";
import { Observable } from "rxjs";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
  MatDatepickerInputEvent,
  MatDialog,
  MatPaginator,
  MatSort,
  MatTableDataSource,
  Sort,
} from "@angular/material";
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import { DatePipe, formatDate } from "@angular/common";

export const MY_FORMATS = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-hr-holidays-list",
  templateUrl: "./hr-holidays-list.component.html",
  styleUrls: ["./hr-holidays-list.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HRHolidaysLsitComponent implements OnInit {
  holidaysListTableDataSource: MatTableDataSource<any>;
  error: string;
  MangemployeeList: any;
  vendorList = [];
  currentMonth = "";
  currentFY = "";
  isFreeze = true;
  saved = false;
  submited = false;
  IsApproved = false;
  LoginEmpCode = "";
  originalData = [];
  isSave: boolean = false;
  currentDate = new Date();
  minDate: any;
  minDateApporver: any;
  holidaysListTableForm: any;
  loginName = "";
  holidaysListDetails: any;
  lstData: any;
  @ViewChild("holidaysListTablePaginationAll", { static: true })
  holidaysListTablePaginationAll: MatPaginator;
  @ViewChild("holidaysListTableDatasortAll", { static: true })
  holidaysListTableDatasortAll: MatSort;
  holidaysListHeaders: string[] = [
    "Id",
    "FromDate",
    "ToDate",
    "Year",
    "Form",
    "Publish",
    "remove",
  ];
  holidaysListTableHeaders = this.submitHolidayListFormBuilder.array([]);

  constructor(
    private _service: HolidayListService,
    private config: AppConfig,
    public router: Router,
    private toastr: ToastrService,
    public _userService: UserService,
    private submitHolidayListFormBuilder: FormBuilder,
    public dialog: MatDialog
  ) {
    this.holidaysListTableForm = this.submitHolidayListFormBuilder.group({
      holidaysListTableHeaders: this.holidaysListTableHeaders,
    });
    this.holidaysListTableDataSource = new MatTableDataSource();
    this.LoginEmpCode = this._userService.getEmpCode().toString();
  }

  ngOnInit() {
    var today = new Date();
    this.getAllHolidaysList();
    this.minDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    this.minDateApporver = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + 1
    );
    this.loginName = this._userService.getEmail();
  }

  ngDoCheck() {
    let newData = this.holidaysListTableDataSource.data || [];
    newData =
      newData &&
      newData.map(({ FromDate, ToDate, Publish, Year }) => ({
        FromDate,
        ToDate,
        Publish,
        Year,
      }));

    if (this.isDataChanged(this.originalData, newData)) {
      this.isSave = true;
    } else {
      this.isSave = false;
    }
  }

  // Deep comparison of objects
  isDataChanged(oldData: any, newData: any): boolean {
    return JSON.stringify(oldData) === JSON.stringify(newData);
  }

  createHolidayDetails() {
    var row = {
      Id: null,
      FromDate: null,
      ToDate: null,
      Year: null,
      Publish: null,
      remove: null,
    };
    return row;
  }

  filterEmployee(values, NamePerRecords) {
    return values.filter((value) =>
      !!value.NamePerRecords && value.NamePerRecords != ""
        ? value.NamePerRecords.toLowerCase().includes(
            NamePerRecords.toLowerCase()
          )
        : ""
    );
  }

  removeSubmittedRecord(index: number, row: any) {
    const msg = "Are you sure you want to delete this record?";
    const dialogData = new ConfirmDialogModel(" ", msg, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.holidaysListTableHeaders.value.splice(index, 1);
          var arr = this.holidaysListTableHeaders.value;
          this.holidaysListTableHeaders.clear();
          for (var i = 0; i < arr.length; i++) {
            this.createHolidayListFormGroup(arr[i]);
          }
          let data = this.holidaysListTableDataSource.data;
          data.splice(index, 1);
          this.holidaysListTableDataSource.data = data;
          this.deleteHolidayListDetails(row);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  deleteHolidayListDetails(row) {
    if (row.Id > 0) {
      this._service.DeleteHolidayDetails({ Id: row.Id }).subscribe(
        (data: any[]) => {
          this.toastr.success("Deleted Successfully");
          this.getAllHolidaysList();
        },
        (error) => (this.error = error)
      );
    }
  }

  addHolidayListRow() {
    this.holidaysListTableDataSource.data.push(this.createHolidayDetails());
    this.holidaysListTableDataSource.filter = "";
    this.createHolidayListFormGroup();
  }

  changed(row) {
    row.IsUpdated = true;
  }

  mangerSubmited() {
    this.submited = true;
    var datePipe = new DatePipe("en-US");
    if (
      this.holidaysListTableDataSource != null &&
      this.holidaysListTableDataSource.data.length > 0
    ) {
      for (var i = 0; i < this.holidaysListTableDataSource.data.length; i++) {
        if (this.holidaysListTableDataSource.data[i] != null) {
          this.holidaysListTableDataSource.data[i].FromDate =
            this.holidaysListTableDataSource.data[i].FromDate != null &&
            this.holidaysListTableDataSource.data[i].FromDate != ""
              ? new Date(
                  datePipe.transform(
                    this.holidaysListTableDataSource.data[i].FromDate,
                    this.config.dateFormat()
                  )
                )
              : this.holidaysListTableDataSource.data[i].FromDate;
          this.holidaysListTableDataSource.data[i].ToDate =
            this.holidaysListTableDataSource.data[i].ToDate != null &&
            this.holidaysListTableDataSource.data[i].ToDate != ""
              ? new Date(
                  datePipe.transform(
                    this.holidaysListTableDataSource.data[i].ToDate,
                    this.config.dateFormat()
                  )
                )
              : this.holidaysListTableDataSource.data[i].ToDate;
        }
      }
      for (var i = 0; i < this.holidaysListTableDataSource.data.length; i++) {
        var data = this.holidaysListTableDataSource.data[i];
        const duplicateRecordsExists =
          this.holidaysListTableDataSource.data.find(
            (existingSkill, index) =>
              existingSkill.FromDate != null &&
              data.FromDate != null &&
              existingSkill.ToDate != null &&
              data.ToDate != null &&
              new Date(existingSkill.FromDate).getTime() ===
                new Date(data.FromDate).getTime() &&
              new Date(existingSkill.ToDate).getTime() ===
                new Date(data.ToDate).getTime() &&
              index !== i
          );
        if (duplicateRecordsExists) {
          this.toastr.warning(
            "From date To date must be unique in holidays list."
          );
          return;
        }
      }
    }

    this.SaveConfirmation();
  }


  mangerSaved() {
    this.saved = true;
    var datePipe = new DatePipe("en-US");
    var arr = this.holidaysListTableDataSource.data;
    this.holidaysListTableHeaders.clear();
    for (var i = 0; i < arr.length; i++) {
      this.createHolidayListFormGroup(arr[i]);
    }
    this.holidaysListTableForm.markAllAsTouched();
    if (this.holidaysListTableForm.invalid) {
      this.toastr.warning("Please fill the required fields");
      const hedaers = this.holidaysListTableForm.get(
        "holidaysListTableHeaders"
      ) as FormArray;
      hedaers.controls.forEach((control, index) => {
        if (control.invalid) {
        }
      });
      return;
    }
    if (
      this.holidaysListTableDataSource != null &&
      this.holidaysListTableDataSource.data.length > 0
    ) {
      for (var i = 0; i < this.holidaysListTableDataSource.data.length; i++) {
        if (this.holidaysListTableDataSource.data[i] != null) {
          this.holidaysListTableDataSource.data[i].FromDate =
            this.holidaysListTableDataSource.data[i].FromDate != null &&
            this.holidaysListTableDataSource.data[i].FromDate != ""
              ? new Date(
                  datePipe.transform(
                    this.holidaysListTableDataSource.data[i].FromDate,
                    this.config.dateFormat()
                  )
                )
              : this.holidaysListTableDataSource.data[i].FromDate;
          this.holidaysListTableDataSource.data[i].ToDate =
            this.holidaysListTableDataSource.data[i].ToDate != null &&
            this.holidaysListTableDataSource.data[i].ToDate != ""
              ? new Date(
                  datePipe.transform(
                    this.holidaysListTableDataSource.data[i].ToDate,
                    this.config.dateFormat()
                  )
                )
              : this.holidaysListTableDataSource.data[i].ToDate;
        }
      }
      for (var i = 0; i < this.holidaysListTableDataSource.data.length; i++) {
        var data = this.holidaysListTableDataSource.data[i];
        const duplicateRecordsExists =
          this.holidaysListTableDataSource.data.find(
            (existingSkill, index) =>
              existingSkill.FromDate != null &&
              data.FromDate != null &&
              existingSkill.ToDate != null &&
              data.ToDate != null &&
              new Date(existingSkill.FromDate).getTime() ===
                new Date(data.FromDate).getTime() &&
              new Date(existingSkill.ToDate).getTime() ===
                new Date(data.ToDate).getTime() &&
              index !== i
          );
        if (duplicateRecordsExists) {
          this.toastr.warning(
            "From date To date must be unique in holidays list."
          );
          return;
        }
      }
    }
    this.SaveConfirmation();
  }

  saveHolidayListRecord() {
    var result = this.holidaysListTableDataSource.data;
    if (result != null && result.length > 0) {
      this._service.SaveHolidayDetails(result).subscribe(
        (data: any[]) => {
          if (this.submited == true) {
            this.toastr.success("Submitted Successfully");
          } else {
            this.toastr.success("Saved Successfully");
          }
          this.getAllHolidaysList();
        },
        (error) => (this.error = error)
      );
    }
  }

  getHolidaysListDetails(Id: number): Observable<any[]> {
    return new Observable((observer) => {
      this._service.GetHolidayListDetails(Id).subscribe(
        (data: any[]) => {
          if (data != null && data.length > 0) {
            observer.next(data);
            observer.complete();
          } else {
            observer.next([]);
            observer.complete();
          }
        },
        (error) => {
          observer.error(error);
        }
      );
    });
  }

  getAllHolidaysList() {
    this.holidaysListTableDataSource.data = [];
    this._service.GetHolidayDetails().subscribe(
      (data: any[]) => {
        if (data != null && data.length > 0) {
          //let validationArray = this.submitHolidayListFormBuilder.array([]);

          for (var i = 0; i < data.length; i++) {
            this.createHolidayListFormGroup(data[i]);
          }
          //this.holidaysListTableForm.setControl(
          //  "holidaysListTableHeaders",
          //  validationArray
          //);
          this.holidaysListTableDataSource.data = data;
          this.originalData =
            data &&
            data.map(({ FromDate, ToDate, Publish, Year }) => ({
              FromDate,
              ToDate,
              Publish,
              Year,
            }));
          this.holidaysListTableDataSource.paginator =
            this.holidaysListTablePaginationAll;
          this.holidaysListTableDataSource.sort =
            this.holidaysListTableDatasortAll;
        }
      },
      (error) => (this.error = error)
    );
  }

  checkDisabled(isPublished) {
    if (isPublished) {
      return false;
    } else {
      var count =
        this.holidaysListTableDataSource != null &&
        this.holidaysListTableDataSource.data.length > 0
          ? this.holidaysListTableDataSource.data.filter(
              (data) => data.Publish == true
            ).length
          : 0;
      if (count >= 2) return true;
      else return false;
    }
  }

  SaveConfirmation() {
    const msg = "Are you sure you want to Save the record(s)?";
    const dialogData = new ConfirmDialogModel(" ", msg, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "800px",
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.saveHolidayListRecord();
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  setDate(event: any): any {
    const selectedDate = event.value;
    if (selectedDate) {
      const d = new Date(selectedDate);
      return new Date(
        d.getFullYear(),
        d.getMonth(),
        d.getDate(),
        d.getHours(),
        d.getMinutes() - d.getTimezoneOffset()
      ).toISOString();
    }
    return "";
  }

  FromDateChanged(row, event: MatDatepickerInputEvent<Date>, type) {
    if (row.Id != null) {
      this.getHolidaysListDetails(row.Id).subscribe((details) => {
        const validDates: Date[] = details
          .filter((item) => item.Date !== null)
          .map((item) => new Date(item.Date!));
        if (validDates.length > 0) {
          const minDate = new Date(
            Math.min(...validDates.map((date) => date.getTime()))
          );
          const maxDate = new Date(
            Math.max(...validDates.map((date) => date.getTime()))
          );
          var presentDate = new Date(this.setDate(event));

          presentDate.setHours(0, 0, 0, 0);

          if (presentDate.getTime() > minDate.getTime() && type == "fromDate") {
            this.toastr.warning(
              "From Date should not be greater than " +
              formatDate(minDate, "dd-MMM-yyyy", "en_US")
            );
            row.FromDate = null;
            return;
          } else if (
            presentDate.getTime() < maxDate.getTime() &&
            type == "toDate"
          ) {
            var date = maxDate;
            date.setDate(date.getDate() + 1);
            this.toastr.warning(
              "To Date should not be less than " +
              formatDate(date, "dd-MMM-yyyy", "en_US")
            );
            row.ToDate = null;
            return;
          }
        }
      });
    }
  }

  rowClickOpenDetails(row) {
    this.router.navigateByUrl("/holidaylistdetails/" + row.Id);
  }

  private createHolidayListFormGroup(item: any = null) {
    var row;
    if (item != null) {
      item.FromDate = item.FromDate != null ? new Date(item.FromDate) : item.FromDate
      item.ToDate = item.ToDate != null ? new Date(item.ToDate) : item.ToDate;
    }
    
    if (item != null) {
      row = this.submitHolidayListFormBuilder.group({
        Id: [item.Id],
        FromDate: [item.FromDate, Validators.required],
        ToDate: [item.ToDate, Validators.required],
        Year: [item.Year, Validators.required],
        Form: [item.Form],
        Publish: [item.Publish],
      });
    } else {
      row = this.submitHolidayListFormBuilder.group({
        Id: [null],
        FromDate: [null, Validators.required],
        ToDate: [null, Validators.required],
        Year: [null, Validators.required],
        Form: [null],
        Publish: [null],
      });
    }
    this.holidaysListTableHeaders.push(row);
  }
}
